import { render, staticRenderFns } from "./ExpandedWidgets.vue?vue&type=template&id=80fa39be&scoped=true&"
import script from "./ExpandedWidgets.vue?vue&type=script&lang=js&"
export * from "./ExpandedWidgets.vue?vue&type=script&lang=js&"
import style0 from "./ExpandedWidgets.vue?vue&type=style&index=0&id=80fa39be&prod&lang=scss&"
import style1 from "./ExpandedWidgets.vue?vue&type=style&index=1&id=80fa39be&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80fa39be",
  null
  
)

export default component.exports